import * as CONFIG from '@reolink-web/config-center';

export const env = CONFIG.ENV;
export const baseUrl = CONFIG.API_URL;
export const OFFICIAL_DOMAIN = CONFIG.OFFICIAL_URL;
export const REOLINK_OFFICIAL_DOMAIN = import.meta.env.REO_REOLINK_DOMAIN;
export const CLIENT_ID = import.meta.env.REO_CLIENT_ID;
export const STORE = CONFIG.STORE_URL;
export const COOKIE_DOMAIN = CONFIG.OFFICIAL_COOKIE_DOMAIN;
export const MY_ACCOUNT = CONFIG.ACCOUNT_CENTER_URL;
export const ERROR_REPORT_URL = CONFIG.API_URL + '/v2/front-end/errors';
export const REO_STORE_DOMAIN = CONFIG.STORE_URL;
export const REO_CDN_DOMAIN = CONFIG.STATIC_CDN_URL;
export const REO_CLOUD_DOMAIN = CONFIG.CLOUD_URL;
export const REO_COMMUNITY_DOMAIN = import.meta.env.REO_COMMUNITY_DOMAIN;
export const REO_SUPPORT_DOMAIN = import.meta.env.REO_SUPPORT_DOMAIN;
export const baseUrlV3 = baseUrl + '/reo-v3/';
export const baseUrlApiV2 = baseUrl + '/v2/';
export type TMedia = 'mobile' | 'pc';

export default {
    env,
    baseUrl,
    baseUrlV3,
    baseUrlApiV2,
    COOKIE_DOMAIN,
    STORE,
    OFFICIAL_DOMAIN,
    REOLINK_OFFICIAL_DOMAIN,
    CLIENT_ID,
    MY_ACCOUNT,
    ERROR_REPORT_URL,
    REO_STORE_DOMAIN,
    REO_CLOUD_DOMAIN,
    REO_COMMUNITY_DOMAIN,
    REO_SUPPORT_DOMAIN,
    REO_CDN_DOMAIN,
};
